import { useAppDispatch } from './state'
import { getPayments as getPaymentsAPI } from '../api/payments'
import { setPayments, setPaymentsIsLoading } from '../state/slices/payments_slice'

export const usePayments = () => {
  const dispatch = useAppDispatch()

  const getPayments = async () => {
    dispatch(setPaymentsIsLoading(true))
    const result = await getPaymentsAPI()

    if (result.data) {
      dispatch(setPayments(result.data))
    }

    dispatch(setPaymentsIsLoading(false))
  }

  return {
    getPayments
  }
}

export default usePayments
